import ApiURL from "./ApiURL";
import axios from "../axios";
import { selectIcon } from "../components/UI/selector";
import {
  setActivity,
  setCount,
  setCoach,
  setRoom,
  setScheduleActivity,
  activeActivity,
  setListCoach,
  setTemplate,
  setLocation,
  setMTClassType,
  setMemberSummaryData,
  setTransaction,
  SetMediaClip,
  SetCategoryData,
  SetClassByCategory,
  setGymUser,
  SetAnnouncementData,
  setPlanList,
  setCouponList,
  setTransactionsList,
  setSubscriptionsList,
  setMember,
} from "./SetApiResponse";
import {
  sortData,
  CheckActiveGym,
  checkRole,
  CheckValue,
} from "./CommonFunction";
import { userData } from "./subscriberService";
import { access, staticVar } from "./Constants";
import { isArray } from "lodash";

export const PostMethod = (url, data) => {
  return axios.post(ApiURL[url], data);
};

export const DeleteMethod = (url, data) => {
  return axios.delete(ApiURL[url], { data: data });
};

export const DeleteMethodV2 = (url, data) => {
  const queryString = Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");

  const fullUrl = `${ApiURL[url]}?${queryString}`;

  return axios.delete(fullUrl);
};

export const GetMethod = (url, data) => {
  let temp = "";
  Object.keys(data).forEach((el, index) => {
    if (index === 0) {
      temp += "?";
    } else {
      temp += "&";
    }
    if (typeof data[el] === "object") {
      Object.keys(data[el]).forEach((el1, index1) => {
        if (index1 !== 0) {
          temp += "&";
        }
        temp += `${el}[${el1}]=${data[el][el1]}`;
      });
    } else {
      temp += `${el}=${data[el]}`;
    }
  });
  return axios.get(`${ApiURL[url]}${temp}`);
};

export const AddBulkMember = async (data) => {
  try {
    const response = await axios.post(ApiURL._addBulkMember, data);
    let count = response.data.data.gymLinks
      ? response.data.data.gymLinks.rowCount || 0
      : 0;
    count += response.data.data.invites
      ? response.data.data.invites.rowCount || 0
      : 0;
    return {
      list: {
        add: count,
        duplicate: data.emails.length - count,
      },
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetBulkMemberList = async (data) => {
  try {
    const response = await axios.post(ApiURL._getBulkMember, data);
    const list = response.data.data.map((el) => ({
      email: el.email || "---",
      addedAt: el.timestamp || new Date(),
    }));
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetRoomList = async (data) => {
  try {
    const response = await axios.post(ApiURL._getRooms, data);
    const list = response.data.data.rooms.map((el) => setRoom(el));
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetSingleClassSummary = async (data) => {
  try {
    const response = await axios.post(ApiURL._getActivitySummary, data);
    const list = {
      usersInActivity: response.data.data.usersInActivity,
      class_summary: { ...response.data.data.class_summary },
    };
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetGymList = async (data) => {
  try {
    const response = await axios.post(ApiURL._getCoachMember, data);
    const list = response.data.data.list.map((el) =>
      setGymUser({ ...el, gym_id: el.user_id })
    );
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetTransactionList = async (data) => {
  try {
    const response = await axios.post(ApiURL._listInvoices, data);
    const list = response.data.data.map((el) =>
      setTransaction({ ...el, gym_id: el.user_id })
    );
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetLocationsList = async (data) => {
  try {
    const response = await axios.post(ApiURL._getLocation, data);
    const list = response.data.data.location_list.map((el) => setLocation(el));
    return {
      list: list,
      status: true,
      count: response.data.data.locationCount.count || 0,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetCoachList = async (data) => {
  try {
    const response = await axios.post(ApiURL._getCoachMember, data);
    const list = response.data.data.list.map((el) => setListCoach(el));
    return {
      list: list,
      statistics: response.data.data.statistics || null,
      count: setCount(response.data.data.count),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetTemplateList = async (data) => {
  try {
    const response = await axios.post(ApiURL._getTemplate, data);
    const list = response.data.data.list.map((el) => setTemplate(el));
    return {
      list: list,
      statistics: response.data.data.statistics || null,
      count: setCount(response.data.data.count),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetMemberSummaryList = async (data) => {
  try {
    const response = await axios.post(ApiURL._memberWoHistory, data);
    const list = response.data.data.list.map((el) => setMemberSummaryData(el));
    return {
      list: list,
      statistics: response.data.data.statistics || null,
      count: setCount(response.data.data.count),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const GetPendingInvoices = async () => {
  const data = {
    gym_id: userData.selectedGym.gym_id,
    limit: 50,
  };
  try {
    const response = await axios.post(ApiURL._listPendingInvoices, data);
    return {
      data:
        response.data.data.standardPendingInvoices || staticVar.defaultErrorMsg,
      status: true,
      pendingAmount: response.data.data.pendingAmount,
    };
  } catch (err) {
    return {
      data: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const ClearPendingInvoices = async () => {
  const data = {
    gym_id: userData.selectedGym.gym_id,
  };
  try {
    const response = await axios.post(ApiURL._clearPendingInvoices, data);
    return { data: response.data.data || {}, status: true };
  } catch (err) {
    return {
      data: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getTemplateDatas = (id) => {
  return PostMethod("_getTemplateDetail", { class_template_id: id }).then(
    (res) => {
      return setTemplate(res.data.data);
    }
  );
};

export const UploadMedia = async (data, progressEvent) => {
  try {
    const res = await axios.post(ApiURL["_uploadMedia"], data, progressEvent);
    return { status: true, data: res.data.data };
  } catch (err) {
    return {
      status: false,
      error: err.response ? err.response.data : staticVar.defaultErrorMsg,
    };
  }
};

export const AddMedia = async (data) => {
  try {
    const res = await PostMethod("_addMedia", data);
    return { status: true, data: res.data.data };
  } catch (err) {
    return {
      status: false,
      error: err.response ? err.response.data : staticVar.defaultErrorMsg,
    };
  }
};

export const GetMedia = async (data) => {
  try {
    const res = await PostMethod("_getMedia", data);
    const list = res.data.data.list.map((el) => SetMediaClip(el));
    return { status: true, data: list };
  } catch (err) {
    return {
      status: false,
      error: err.response ? err.response.data : staticVar.defaultErrorMsg,
    };
  }
};

export const GetMemberList = async (data) => {
  try {
    const response = await axios.post(ApiURL._getCoachMember, data);
    const list = response.data.data.list.map((el) => setListCoach(el));
    return {
      list: list,
      statistics: response.data.data.statistics || null,
      count: setCount(response.data.data.count),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const UploadActivityImage = async (data) => {
  try {
    const response = await axios.post(ApiURL._uploadFile, data);
    return {
      original: response.data.data.original,
      thumb: response.data.data.thumbnail,
      status: true,
    };
  } catch (err) {
    return {
      original: "",
      thumb: "",
      status: false,
      err: err.response ? err.response.data : staticVar.defaultErrorMsg,
    };
  }
};

export const UploadClassImage = async (data) => {
  try {
    const response = await axios.post(ApiURL._uploadClassFile, data);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      status: false,
      err: err.response ? err.response.data : staticVar.defaultErrorMsg,
    };
  }
};

export const uploadImages = async (data) => {
  try {
    const response = await axios.post(ApiURL["_uploadImage"], data);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      status: false,
      err: err.response ? err.response.data : staticVar.defaultErrorMsg,
    };
  }
};

export const getActivityData = async (data) => {
  try {
    const response = await axios.post(ApiURL._getActivity, data);
    const list = response.data.data.list.map((el) => setActivity(el));
    return {
      list: list,
      statistics: response.data.data.statistics || null,
      count: setCount(response.data.data.count),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};

export const getActivitySummary = async (data) => {
  try {
    const response = await axios.post(ApiURL._activityList, data);
    const list = response.data.data.list.map((el) => setActivity(el));
    return {
      list: list,
      statistics:
        response.data.data.gymDashboardData ||
        response.data.data.coachDashboardData ||
        null,
      count: setCount(response.data.data.count),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};

export const ActiveRoomDetail = async (data) => {
  try {
    const response = await axios.post(ApiURL._activeRoomDetail, data);
    const list = activeActivity(response.data.data);
    return { data: list, status: true };
  } catch (err) {
    return {
      data: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const StartClass = async (data) => {
  try {
    const response = await axios.post(ApiURL._startWorkout, data);
    return { data: response.data.data, status: true };
  } catch (err) {
    console.error("start workout", err);
    return {
      data: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const RemoveUser = async (data) => {
  try {
    const response = await axios.post(ApiURL._removeUser, data);
    return {
      data: response.data.data || staticVar.defaultErrorMsg,
      status: true,
    };
  } catch (err) {
    return {
      data: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getSingleActiveDetail = async (data) => {
  try {
    const response = await axios.post(ApiURL._activeRoomDetail, data);
    const list = setScheduleActivity(response.data.data);
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getAttemptStats = async (data) => {
  try {
    const response = await axios.post(ApiURL._attemptStats, data);
    return { list: response.data.data.user_summary, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getScheduledActivityData = async (data) => {
  try {
    const response = await axios.post(ApiURL._getScheduledActivity, data);
    const list = response.data.data.list.map((el) => setScheduleActivity(el));
    return {
      list: list,
      statistics: null,
      count: setCount(response.data.data.count),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};

export const getActivityDataByIdForSchedule = async (data, status) => {
  try {
    const response = await axios.post(
      ApiURL[status ? "_getActivityData" : "_getActivityDataThirdparty"],
      data
    );
    return { list: setScheduleActivity(response.data.data), status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};

export const getActivityDataByIdForOndemand = async (data) => {
  try {
    const response = await axios.post(ApiURL._getActivityData, data);
    return { list: setActivity(response.data.data), status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};

export const getCategoryData = async (data) => {
  try {
    const response = await axios.post(ApiURL._categoryData, data);
    const list = response.data.data.list.map((el) => SetCategoryData(el));
    return {
      list: list,
      statistics: null,
      status: true,
      count: {
        count: response.data.data.category_total_count || 0,
        category_featured_count: Number(
          response.data.data.category_featured_count || 0
        ),
      },
    };
    // return { list: list, statistics: null, status: true, count: response.data.data.category_total_count || 0 };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};
export const getClassByCategory = async (data) => {
  try {
    const response = await axios.post(ApiURL._classByCategoryData, data);
    const list = response.data.data.list.map((el) => SetClassByCategory(el));
    return {
      list: list,
      statistics: null,
      status: true,
      count: {
        count: response.data.data.total_class_count || 0,
      },
    };
    // return { list: list, statistics: null, status: true, count: response.data.data.category_total_count || 0 };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};
export const getAnnouncementData = async (data) => {
  try {
    const response = await GetMethod("_announcementData", data);
    // console.log(response.data.data);
    const list = response.data.data.map((el) => SetAnnouncementData(el));
    const filteredData = list.sort((a, b) => {
      if (a.status === "PUBLISHED" && b.status !== "PUBLISHED") {
        return -1;
      }
      if (a.status !== "PUBLISHED" && b.status === "PUBLISHED") {
        return 1;
      }
      if (a.status === "UNPUBLISHED" && b.status !== "UNPUBLISHED") {
        return -1;
      }
      if (a.status !== "UNPUBLISHED" && b.status === "UNPUBLISHED") {
        return 1;
      }
      return 0;
    });
    return {
      list: filteredData,
      statistics: null,
      status: true,
      count: {
        // count: response.data.data.category_total_count || 0,
        // category_featured_count: Number(response.data.data.category_featured_count || 0),
      },
    };
    // return { list: list, statistics: null, status: true, count: response.data.data.category_total_count || 0 };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      count: 0,
      status: false,
    };
  }
};
export const getAnnouncementDetails = async (data) => {
  try {
    const response = await GetMethod("_announcementDetail", data);
    return {
      list: SetAnnouncementData(response.data.data),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};
export const uploadMediaAnnouncement = async (data) => {
  try {
    const response = await axios.post(ApiURL._uploadMediaAnnouncement, data);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      status: false,
      err: err.response ? err.response.data : staticVar.defaultErrorMsg,
    };
  }
};
export const updateActivityStatus = async (data) => {
  try {
    const response = await axios.post(ApiURL._updateActivityStatus, data);
    const list = setActivity(response.data.data);
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const cancelScheduleActivity = async (data) => {
  try {
    await axios.post(ApiURL._cancelScheduledActivity, data);
    return { list: true, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const OpenWaitingRoom = async (data) => {
  try {
    await axios.post(ApiURL._openWaitingRoom, data);
    return { list: true, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const CoachDeepLink = async (data) => {
  try {
    const response = await axios.post(ApiURL._coachGenerateLink, data);
    return { list: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const EditScheduleActivity = async (data) => {
  try {
    const response = await axios.post(ApiURL._editScheduledActivity, data);
    return { list: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const AssignCoach = async (data) => {
  try {
    const response = await axios.post(ApiURL._assignCoach, data);
    return { list: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getCoach = async (data) => {
  try {
    const response = await axios.post(ApiURL._getCoach, data);
    return response.data.data.map((el) => setCoach(el)).sort(sortData);
  } catch (err) {
    return err.response ? err.response.data : staticVar.defaultErrorMsg;
  }
};
export const getMember = async (data) => {
  try {
    const response = await axios.post(ApiURL._getMember, data);
    const list = response.data.data.map((el) => setMember(el)).sort(sortData);
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getRoom = async (data) => {
  try {
    const response = await axios.post(ApiURL._getRooms, data);
    const list = response.data.data.rooms.map((el) => setRoom(el));
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getMtClassType = async (data) => {
  try {
    const response = await axios.post(ApiURL._getMtClassType, data);
    const list = response.data.data.class_types.map((el) => setMTClassType(el));
    return {
      list: list,
      status: true,
      pagination: response.data.data.pagination,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const SetActivtyVideoStatus = async (data) => {
  try {
    const response = await axios.post(ApiURL._getS3SignedUrlProgress, data);
    return response;
  } catch (err) {
    return err;
  }
};

export const CreatTemplate = async (data) => {
  try {
    const response = await axios.post(ApiURL._addEditTemplate, data);
    return { list: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getAvailablePlans = async (data) => {
  try {
    const response = await axios.post(ApiURL._listPricings, data);
    return { list: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getPlanDetails = async (data) => {
  try {
    const response = await GetMethod("_planDetail", data);
    return {
      list: setPlanList(response.data.data),
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};
export const getPlanList = async (data) => {
  try {
    const response = await GetMethod("_getPlanList", data);
    const list = response.data.data.map((el) => setPlanList(el));
    return {
      list: list,
      status: true,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};
export const getCouponList = async (data) => {
  try {
    const response = await GetMethod("_getCouponList", data);
    const list = response.data.data.data.map((el) => setCouponList(el));
    return {
      list: list,
      status: true,
      count: 0,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};
export const getSubscriptionsList = async (data) => {
  try {
    const response = await GetMethod("_getSubscriptionsList", data);
    const list = response.data.data.map((el) => setSubscriptionsList(el));
    return {
      list: list,
      status: true,
      count: 0,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};
export const getTransactionsList = async (data) => {
  try {
    const response = await GetMethod("_getTransactionsList", data);
    let list = [];
    if (isArray(response.data.data.data)) {
      list = response.data.data.data.map((el) => setTransactionsList(el));
    } else {
      list = [setTransactionsList(response.data.data)];
    }
    return {
      list: list,
      status: true,
      count: 0,
    };
  } catch (err) {
    return {
      list: err.response ? err.response.data : staticVar.defaultErrorMsg,
      status: false,
    };
  }
};

export const getActivityLogo = async (data) => {
  try {
    const response = await axios.post(ApiURL._activityLogos, data);
    const res = response.data.data.logos.map((el) => {
      if (el !== null) {
        return {
          // label: el.Key,
          // value: el.url,
          // image: el.url,
          name: el.Key || "",
          id: el.activity_logo_thumb || el.url,
          keyValue: "id",
          thumb: el.activity_logo_thumb || el.url || selectIcon("userDummy"),
          original:
            el.activity_logo_original ||
            el.activity_logo_thumb ||
            el.url ||
            selectIcon("userDummy"),
        };
      }
      return null;
    });
    return { list: res };
  } catch (err) {
    return { list: [] };
  }
};

export const accessTokenApi = async (staticProps) => {
  try {
    const data = {
      device_type: "WEB",
      app_version: "0",
      timezone_offset: "0",
    };
    if (localStorage.getItem("setId")) {
      data["device_id"] = localStorage.getItem("setId");
    } else {
      return { status: false, logout: true };
    }

    const response = await axios.post(ApiURL._getSignUpData, data);
    return setAccessTokenRespone(response, staticProps).then((res) => ({
      status: true,
      ...res,
    }));
  } catch (err) {
    return {
      status: false,
      err: err,
      gymsArray: [],
      text: null,
      logout: err.response && err.response.data.statusCode === 401,
    };
  }
};

export const setAccessTokenRespone = async (response, staticProps) => {
  const gymsArray = await CheckActiveGym(response.data.data, staticProps);
  let coachStatus = { text: null, gym: null };
  staticVar.accessToken = response.data.data.access_token;
  let selectedGym = {};
  let userDetail = { ...response.data.data };
  if (gymsArray.length) {
    gymsArray.forEach((el) => {
      el["downloadTemplate"] = staticVar.bulkDownload;
      if (!CheckValue(el.gym_access_control_list)) {
        el.gym_access_control_list = {};
      }
      if (!CheckValue(el.app_id)) {
        el.app_id = "TRIBE";
      }
      if (!CheckValue(el.is_stripe_enabled)) {
        el.is_stripe_enabled = false;
      }
      if (!CheckValue(el.is_sync_required)) {
        el.is_sync_required = false;
      }
      // el.is_sync_required = true;
      if (
        !CheckValue(el.gym_access_control_list.allowed_featured_category_limit)
      ) {
        el.gym_access_control_list.allowed_featured_category_limit = 5;
      }
      if (!CheckValue(el.gym_access_control_list.is_studio_payment_enabled)) {
        el.gym_access_control_list.is_studio_payment_enabled = false;
      }
      el["firstOwner"] = el.added_by === response.data.data.user_id;
      // selectedGym.subscription_status = 'NON_PAYER';

      el.gym_access_control_list.is_ivs_streaming_enabled = true;
      el.gym_access_control_list.is_ivs_recording_enabled = true;
      el.gym_access_control_list.is_zoom_streaming_enabled = true;
      el.gym_access_control_list.is_zoom_recording_enabled = true;
    });
    userDetail["gymsArray"] = gymsArray;
    if (!CheckValue(localStorage.getItem("gymCode"))) {
      selectedGym = gymsArray[0];
    } else {
      let temp = gymsArray.filter(
        (el) => el.membership_code === localStorage.getItem("gymCode")
      );
      selectedGym = temp && temp.length ? temp[0] : gymsArray[0];
    }

    localStorage.setItem("gymCode", selectedGym.membership_code);
    access.locationList.value = selectedGym.is_location_enabled;
    userData.selectedGym = selectedGym;
  } else {
    if (checkRole("gym", response.data.data.roles)) {
      coachStatus = CheckGymStatus(response.data.data);
    } else {
      coachStatus = CheckCoachStatus(response.data.data);
    }
  }
  userData.sendData({ ...userDetail });
  return {
    data: response.data.data,
    gymsArray: gymsArray,
    coachStatus: coachStatus,
    userDetail: userDetail,
    selectedGym: selectedGym,
  };
};

export const CheckCoachStatus = (res) => {
  let text = null;
  let gym = {};
  const arr = [
    { status: 0, text: "pending" },
    { status: 2, text: "rejected" },
    { status: 3, text: "inactive" },
    { status: 4, text: "invite" },
  ];
  arr.forEach(async (el) => {
    const temp = res.gyms.filter((el1) => el1.linked_status === el.status);
    if (temp.length && text === null) {
      text = el.text;
      gym = temp[0];
    }
  });
  return { text: text, gym: gym, role: res.roles };
};

export const CheckGymStatus = (res) => {
  let text = null;
  let gym = {};
  const arr = [
    { status: 0, text: "pending" },
    { status: 2, text: "rejected" },
    { status: 3, text: "inactive" },
    { status: 4, text: "invite" },
  ];
  arr.forEach(async (el) => {
    const temp = res.gymsAdded.filter((el1) => el1.linked_status === el.status);
    if (temp.length && text === null) {
      text = el.text;
      gym = temp[0];
    }
  });
  return { text: text, gym: gym, role: res.roles };
};
export const SetAnnouncementVideoStatus = async (data) => {
  try {
    const response = await axios.post(ApiURL._addAnnouncement, data);
    return response;
  } catch (err) {
    return err;
  }
};
